import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="navbar"
export default class extends Controller {
  static targets = ["smallScreenNavbar", "menuButton", "mobileDrawer", "backdrop"]

  connect() {
    // Close menu when clicking outside
    this.handleOutsideClick = this.handleOutsideClick.bind(this)
    // Close menu on escape key
    this.handleEscape = this.handleEscape.bind(this)
  }

  disconnect() {
    document.removeEventListener('click', this.handleOutsideClick)
    document.removeEventListener('keydown', this.handleEscape)
  }

  toggleSmallScreenNavbar() {
    if (this.hasMobileDrawerTarget) {
      // New mobile drawer behavior
      this.isDrawerOpen() ? this.closeDrawer() : this.openDrawer()
    } else if (this.hasSmallScreenNavbarTarget) {
      // Legacy behavior for classic navbar
      if (this.smallScreenNavbarTarget.classList.contains("hidden")) {
        this.openSlidebar()
      } else {
        this.closeSlideBar()
      }
    }
  }

  isDrawerOpen() {
    return this.hasMobileDrawerTarget &&
           !this.mobileDrawerTarget.classList.contains('-translate-x-full') &&
           !this.mobileDrawerTarget.classList.contains('translate-x-full')
  }

  openDrawer() {
    if (!this.hasMobileDrawerTarget) return

    // Show drawer with slide animation
    this.mobileDrawerTarget.classList.remove('-translate-x-full', 'translate-x-full')

    // Show backdrop
    if (this.hasBackdropTarget) {
      this.backdropTarget.classList.remove('hidden', 'pointer-events-none', 'opacity-0')
      this.backdropTarget.classList.add('pointer-events-auto', 'opacity-100')
    }

    // Update button state
    if (this.hasMenuButtonTarget) {
      this.menuButtonTarget.setAttribute('aria-expanded', 'true')
    }

    // Prevent body scroll
    document.body.style.overflow = 'hidden'

    // Add event listeners
    setTimeout(() => {
      document.addEventListener('keydown', this.handleEscape)
    }, 100)
  }

  closeDrawer() {
    if (!this.hasMobileDrawerTarget) return

    // Determine slide direction based on drawer position
    const isLeft = this.mobileDrawerTarget.classList.contains('left-0')
    this.mobileDrawerTarget.classList.add(isLeft ? '-translate-x-full' : 'translate-x-full')

    // Hide backdrop
    if (this.hasBackdropTarget) {
      this.backdropTarget.classList.remove('pointer-events-auto', 'opacity-100')
      this.backdropTarget.classList.add('hidden', 'pointer-events-none', 'opacity-0')
    }

    // Update button state
    if (this.hasMenuButtonTarget) {
      this.menuButtonTarget.setAttribute('aria-expanded', 'false')
    }

    // Restore body scroll
    document.body.style.overflow = ''

    // Remove event listeners
    document.removeEventListener('keydown', this.handleEscape)
  }

  // Legacy methods for classic navbar
  closeSlideBar() {
    if (this.hasSmallScreenNavbarTarget) {
      this.smallScreenNavbarTarget.classList.add("hidden")
      if (this.hasMenuButtonTarget) {
        this.menuButtonTarget.setAttribute('aria-expanded', 'false')
      }
      document.removeEventListener('click', this.handleOutsideClick)
      document.removeEventListener('keydown', this.handleEscape)
    }
  }

  openSlidebar() {
    if (this.hasSmallScreenNavbarTarget) {
      this.smallScreenNavbarTarget.classList.remove("hidden")
      if (this.hasMenuButtonTarget) {
        this.menuButtonTarget.setAttribute('aria-expanded', 'true')
      }
      // Add event listeners after a small delay to prevent immediate triggering
      setTimeout(() => {
        document.addEventListener('click', this.handleOutsideClick)
        document.addEventListener('keydown', this.handleEscape)
      }, 100)
    }
  }

  handleOutsideClick(event) {
    // Close menu if click is outside navbar
    if (!this.element.contains(event.target)) {
      this.closeSlideBar()
    }
  }

  handleEscape(event) {
    if (event.key === 'Escape') {
      if (this.isDrawerOpen()) {
        this.closeDrawer()
      } else {
        this.closeSlideBar()
      }
    }
  }
}
